import gql from 'graphql-tag'
export interface UsersInput {
  name?: string | null
}

export interface SelectionOnUsers {
  id: string
  email: string | null
  uid: string | null
  roles: Array<UserRole>
  name: string | null
  isConfirmed: boolean
}

export interface Users {
  users: Array<SelectionOnUsers>
}

export enum UserRole {
  ADMIN = 'ADMIN',
  USER = 'USER'
}

export default gql`
  query Users($name: String) {
    users(name: $name) {
      id
      email
      uid
      roles
      name
      isConfirmed
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/users.tsx